

























































































import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';
import { TextColor } from '@/classes/tiptap/textcolor';
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { EditorContent, EditorMenuBar },
})
export default class TextEditor extends Vue {
  @Prop({ default: null })
  public value!: string | null;

  @Prop({ default: null })
  public initial!: string | null;

  @Prop({ default: '<p>Beschreibung des Spielabends</p>' })
  public placeholderText!: string;

  private editor: Editor | null = null;
  private selectedColor = 'Standard';
  private colors = [
    { text: 'Rot', value: 'red' },
    { text: 'Gelb', value: 'yellow' },
    { text: 'Grün', value: 'green' },
    { text: 'Blau', value: 'lightblue' },
    { text: 'Cyan', value: 'cyan' },
    { text: 'Pink', value: 'pink' },
  ];
  private supressUpdate = false;
  private innerValue = '';

  public mounted() {
    const content = this.initial ? this.initial : this.placeholderText;
    this.editor = new Editor({
      content,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new TextColor(),
      ],
      onUpdate: (info) => {
        this.$emit('input', info.getHTML());
        this.innerValue = info.getHTML();
      },
    });

    // Send initial event
    this.$emit('input', content);
    this.innerValue = content;
  }

  public reset() {
    this.editor.setContent(this.placeholderText);
  }

  public beforeDestroy() {
    this.editor.destroy();
  }

  public getContent() {
    return this.innerValue;
  }

  @Watch('initial')
  public onValueChange(newValue) {
    this.editor.setContent(newValue, true);
  }
}
